import EmailIcon from "@mui/icons-material/Email";
import HeadsetMicIcon from "@mui/icons-material/HeadsetMic";
import PhoneIcon from "@mui/icons-material/Phone";
import {Card, CardContent, Typography, Box} from "@mui/material";
import Stack from "@mui/material/Stack";
import {useTheme} from "@mui/material/styles";
import ScreenState from "components/ScreenState";
import {useConfigs} from "context/ConfigsContext";
import type {FC} from "react";

type SidebarFooterProps = {
  loading: boolean;
  units: string;
  isMobile: boolean;
};

const SidebarFooter: FC<SidebarFooterProps> = ({loading, units, isMobile}) => {
  const theme = useTheme();
  const {configs, loading: configsLoading} = useConfigs();

  const isLoading = loading || configsLoading;

  const support = configs?.support;
  return (
    <ScreenState loading={isLoading}>
      <Stack
        spacing={1.5}
        sx={{
          px: 1.5,
          py: 1.5,
          borderTop: `1px solid ${theme.palette.divider}`,
        }}>
        {isMobile && (
          <Typography variant="body2" textAlign="center">
            Units: {loading ? "loading…" : units}
          </Typography>
        )}

        {configs && (
          <Card
            variant="outlined"
            sx={{
              backgroundColor: theme.palette.background.default,
            }}>
            <CardContent sx={{p: 1.5, "&:last-child": {pb: 1.5}}}>
              <Stack spacing={1}>
                <Stack direction="row" spacing={1} alignItems="center">
                  <HeadsetMicIcon fontSize="small" color="primary" />
                  <Typography variant="subtitle2" fontWeight={600}>
                    Need help?
                  </Typography>
                </Stack>

                <Box display="flex" alignItems="center" gap={1}>
                  <EmailIcon fontSize="small" color="action" />
                  <Typography variant="body2">{support?.email}</Typography>
                </Box>

                <Box display="flex" alignItems="center" gap={1}>
                  <PhoneIcon fontSize="small" color="action" />
                  <Typography variant="body2">{support?.phone}</Typography>
                </Box>
              </Stack>
            </CardContent>
          </Card>
        )}
      </Stack>
    </ScreenState>
  );
};

export default SidebarFooter;
